import {
    BehaviorSubject,
    distinctUntilChanged,
    filter,
    map,
    merge,
    switchMap,
} from "rxjs";

import { ProductVariantIdManagerInterface } from "./ProductVariantIdManagerInterface";
import { ProductVariantIdProviderInterface } from "./ProductVariantIdProviderInterface";

export class ProductVariantsIdManager
    implements ProductVariantIdManagerInterface
{
    providers$ = new BehaviorSubject<ProductVariantIdProviderInterface[]>([]);
    variantId$ = new BehaviorSubject<number | null>(null);

    constructor() {
        this.providers$
            .pipe(
                map((providers) =>
                    providers.map((provider) => provider.selectVariantId())
                ),
                switchMap((variantIdObservables) =>
                    merge(...variantIdObservables)
                ),
                filter((value) => value !== null),
                distinctUntilChanged()
            )
            .subscribe(this.variantId$);
    }

    public registerProvider(provider: ProductVariantIdProviderInterface): void {
        this.providers$.next([...this.providers$.getValue(), provider]);
    }

    public unregisterProvider(
        provider: ProductVariantIdProviderInterface
    ): void {
        const providers = this.providers$.value;

        const newProviders = providers.filter((item) => item !== provider);
        if (newProviders.length === 0) {
            this.variantId$.next(null);
        }

        this.providers$.next(newProviders);
    }
}
